import { motion } from 'framer-motion';
import { panelMeta } from '../../lib/panelMeta';

function timeGreeting(date = new Date()): string {
  const hour = date.getHours();
  if (hour < 12) return 'Buenos días';
  if (hour < 19) return 'Buenas tardes';
  return 'Buenas noches';
}

export default function GreetingSection({ unread }: { unread: number }) {
  let signal: string;
  if (unread > 0) {
    signal = `Tienes ${unread} ${unread === 1 ? 'consulta nueva' : 'consultas nuevas'} por responder.`;
  } else {
    signal = '¿Qué ajustamos hoy?';
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
    >
      <p className="text-sm text-ui-text-subtle">{timeGreeting()}</p>
      <h1 className="mt-1 font-display text-2xl sm:text-3xl font-semibold text-ui-text leading-tight">
        {signal}
      </h1>
      <p className="mt-1 text-sm text-ui-text-subtle">
        Consola de {panelMeta.productName} — pídele algo o usa una acción rápida.
      </p>
    </motion.div>
  );
}
